import axios from "axios";
import { useQuery } from "react-query";

export const useGetAnnotationSentimentTopics = ({ polarity }) => {
  return useQuery(
    ["annotationSentimentTopics", polarity],
    () =>
      axios
        .get("/api/playground/annotationSentimentTopics", {
          params: { polarity },
        })
        .then((res) => res.data),
    { staleTime: 30 * 60 * 1000, refetchOnWindowFocus: false }
  );
};
